import request from '@u/request'

// 查询讲座列表
export function list(data){
	return request({
		url: '/cms_activity/list',
    method: 'POST',
    data: data || {}
	})
}
// 根据id查询讲座
export function get(data){
	return request({
		url: '/cms_activity/get',
    method: 'POST',
    data: data || {}
	})
}
// 修改讲座信息
export function update(data){
	return request({
		url: '/cms_activity/update',
    method: 'POST',
    data: data || {}
	})
}
// 添加讲座信息
export function add(data){
	return request({
		url: '/cms_activity/add',
    method: 'POST',
    data: data || {}
	})
}
// 二维码信息
export function qrcode(data){
	return request({
		url: '/cms_activity/qrcode',
    method: 'POST',
    data: data || {}
	})
}
// 海报信息
export function cms_poster(data){
	return request({
		url: '/cms_poster/get',
    method: 'POST',
    data: data || {}
	})
}
// 上传图片
export function upload_image(data){
	return request({
		headers:{
			'Content-Type':'application/x-www-form-urlencoded'
		},
		url: '/cms/upload_image',
    method: 'POST',
    data: data || {}
	})
}

// 修改海报信息
export function cms_poster_update(data){
	return request({
		url: '/cms_poster/update',
    method: 'POST',
    data: data || {}
	})
}
// 预览海报
export function cms_poster_preview(data){
	return request({
		url: '/cms_poster/preview',
    method: 'POST',
    data: data || {}
	})
}